import { Link, useSearchParams } from "react-router-dom";
import style from "./TabsNavigate.module.scss";
import cn from "classnames";

export function TabsNavigate() {
    const [queryParams] = useSearchParams();

    return (
        <div className={style.container}>
            <p className={style.pageName}>
                {queryParams.get("tab") === "dashboard" ? "Dashboard" : null}
                {queryParams.get("tab") === "costs" ? "Витрати" : null}
            </p>
            <div className={style.tabsButtons}>
                <Link
                    className={cn(style.button, queryParams.get("tab") === "dashboard" && style.button_active)}
                    to={".?tab=dashboard"}
                >
                    Dashboard
                </Link>
                <Link
                    className={cn(style.button, queryParams.get("tab") === "costs" && style.button_active)}
                    to={".?tab=costs"}
                >
                    Витрати
                </Link>
            </div>
        </div>
    )
}